// eslint-disable-next-line no-shadow
export enum BenefitBagStates {
  ACTIVE = "active",
  CANCELLED = "cancelled",
}
